
import { defineComponent } from "vue";
import CatalogueGrid from "@/components/controls/catalogueGrid/CatalogueGrid.vue";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { requiredRule } from "@/components/controls/catalogueGrid/columns/baseValidationRules";
import { CatalogueColumnConfig } from "@/components/controls/catalogueGrid/columns/catalogueColumnConfig";
import planPanelPropertyCreateEditDialog from "@/components/journals/PlanPanelJournal/PlanPanelPropertyCreateEditDialog.vue";
import { TextBooleanDateTimeColumnConfig } from "@/components/controls/catalogueGrid/columns/textBooleanDateTimeColumnConfig";
import api from "@/services/api";

export default defineComponent({
  components: {
    CatalogueGrid,
  },
  emits: ["updateParent"],
  props: {
    parentModel: { required: true },
    parentEditingConfig: { required: false, type: TableEditingConfig },
    selectMode: { required: false, type: Boolean, default: false },
  },
  methods: {
    async refreshParent() {
      const { data } = await api.get("/PlanPackage/GetEditModel", {
        params: {
          id: this.parentModel.id,
          idParent: this.parentModel.idParent,
        },
      });
      this.$emit("updateParent", data);
    },
  },
  computed: {
    planPanelPropertyCreateEditDialog: function () {
      return planPanelPropertyCreateEditDialog;
    },
    getChangedConfig() {
      return this.editingConfig;
    },
  },
  data() {
    return {
      columns: [
        new CatalogueColumnConfig({
          dataField: "featureDescription",
          caption: "Свойство",
          modelIdField: "featureId",
          modelDescField: "featureDescription",
          keyField: "id",
          displayField: "featureDescription",
          displayDescField: "name",
          catalogueComponentName:
            "catalogues/FeatureCatalogue/FeatureCatalogue",
          descriptionColumnName: "featureDescription",
          validationRules: [requiredRule],
        }),
        new TextBooleanDateTimeColumnConfig({
          dataField: "value",
          dataFieldBoolean: "valueBoolean",
          dataFieldDateTime: "valueDateTime",
          caption: "Значение",
          dataType: "boolean",
          disabled: true,
        }),
      ],
      selectionConfig: new TableSelectionConfig({
        mode: "single",
        hoverStateEnabled: false,
      }),
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        horizontalScroll: true,
      }),
      editingConfig: new TableEditingConfig({
        allowUpdating: (this.parentEditingConfig as any)?.allowUpdating,
        allowAdding: (this.parentEditingConfig as any)?.allowAdding,
        allowDeleting: (this.parentEditingConfig as any)?.allowDeleting,
        confirmDelete: true,
        allowDeleteAll: (this.parentEditingConfig as any)?.allowDeleteAll,
        allowDataFill: false,
        allowExport: false,
        allowClearFilter: false,
        allowDeleteMultipleRows: false,
      }),
      pageSizes: [10, 20, 50, 100],
    };
  },
  created() {
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
  },
});
